export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'sincronizado',
    caption: 'Sincronizado',
    width: 120,
    cellTemplate: 'SouNTemplate'
  },
  {
    dataField: 'segmento',
    caption: 'Descrição'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
